import React from 'react';
import {injectIntl} from 'react-intl';
import {percentualize} from '../../../services/dashboardUtils';
import {fillChartOptions} from '../../../utils/analytics';
import FullscreenChart from './FullscreenChart';

const buildBarChartOptions = (config, data, hints, intl) => {
    return fillChartOptions({
        chart: {
            type: 'bar',
        },
        legend: {enabled: false},
        xAxis: {
            categories: data.categories,
            title: {enabled: false, text: config.title},
        },
        yAxis: {
            title: {enabled: false},
        },
        series: data.series.map((s, i) => ({
            data: s.values.map((value) => percentualize(value, s.count, hints)),
            name: s.name,
            dataLabels: {
                enabled: true,
                format: hints.absolute ? '{point.y}' : '{point.y:.1f}%',
            },
        })),
        tooltip: {
            formatter: function() {
                return `${this.x}: ${this.y}${hints.absolute ? '' : '%'}`;
            },
        },
    }, config, data, hints, intl);
};

const builders = {
    bar: buildBarChartOptions,
};

const buildOptions = (config, data, hints, intl) => {
    if (builders[config.chart]) {
        return builders[config.chart](config, data, hints, intl);
    }
    return builders.bar(config, data, hints, intl);
};

const MultipleChoice = ({intl, data, params, hints}) => (
    <FullscreenChart hints={hints} options={buildOptions(params, data, hints, intl)} customLabel={`n=${data.count}`} />
);

export default injectIntl(MultipleChoice);
